import React from "react";
import { Box, Grid, List, ListItem, Paper, Typography } from "@mui/material";

import "flag-icon-css/css/flag-icons.min.css";
import { StatusIcon } from "./utils/StatusIcon";
import { currencyFormatter, numberFormatter } from "./utils/formatters";

interface DetailsPanelProps {
  isOpen: boolean;
  selectedGroupChildrenRows: any[] | null;
}

const DetailsPanelSummary: React.FC<DetailsPanelProps> = ({
  isOpen,
  selectedGroupChildrenRows,
}) => {
  if (!isOpen) {
    return null;
  }
  let metrics: Array<any> = [];
  let sp_revenue: number = 0;
  let ops: number = 0;
  let gccp: number = 0;
  let net_cp: number = 0;
  let sp_clicks: number = 0;
  let paid_units: number = 0;
  let csales: number = 0;
  let sb_revenue: number = 0;
  let sb_clicks: number = 0;
  let sp_attributed_ops_1day: number = 0;
  let statusMap = new Map();

  statusMap.set("Status", "Count");

  function getMetrics(rows: any[]) {
    rows.forEach((weblabIdGroup: any, index: number) => {
      weblabIdGroup.childrenAfterAggFilter.forEach(
        (treatmentGroup: any, index: number) => {
          treatmentGroup.childrenAfterAggFilter.forEach(
            (weblab: any, index: number) => {
              sp_revenue += weblab.data.sp_revenue_impact;
              sp_clicks += weblab.data.sp_clicks_impact;
              paid_units += weblab.data.paid_units_impact;
              ops += weblab.data.ops_impact;
              gccp += weblab.data.gccp_impact;
              net_cp += weblab.data.net_cp_impact;
              csales += weblab.data.csales_impact;
              sb_revenue += weblab.data.sb_revenue_impact;
              sb_clicks += weblab.data.sb_clicks_impact;
              sp_attributed_ops_1day += weblab.data.sp_attributed_ops_1day || 0;

              if (statusMap.has(weblab.data.status)) {
                statusMap.set(
                  weblab.data.status,
                  statusMap.get(weblab.data.status) + 1
                );
              } else {
                statusMap.set(weblab.data.status, 1);
              }
            }
          );
        }
      );
    });
    metrics.push({
      label: "",
      impact: "Impact",
    });
    metrics.push({
      label: "SP Revenue",
      impact: sp_revenue,
    });
    metrics.push({
      label: "OPS",
      impact: ops,
    });
    metrics.push({
      label: "GCCP",
      impact: gccp,
    });
    metrics.push({
      label: "Net CP",
      impact: net_cp,
    });
    metrics.push({
      label: "SP Clicks",
      impact: sp_clicks,
    });
    metrics.push({
      label: "Paid Units",
      impact: paid_units,
    });
    metrics.push({
      label: "CSales",
      impact: csales,
    });
    metrics.push({
      label: "SP Attr. OPS (1-day)",
      impact: sp_attributed_ops_1day,
    });
    metrics.push({
      label: "SB Revenue",
      impact: sb_revenue,
    });
    metrics.push({
      label: "SB Clicks",
      impact: sb_clicks,
    });
    return statusMap;
  }
  getMetrics(selectedGroupChildrenRows!);

  return (
    <Box p={2}>
      <Grid container spacing={2} marginTop={2}>
        <Grid item xs={12} sm={6}>
          <Paper elevation={3} sx={{ padding: 1, marginBottom: 1 }}>
            <List dense>
              {Array.from(statusMap).map(([key, value]) => (
                <ListItem key={key} divider>
                  <Grid container spacing={1}>
                    <Grid item xs={5}>
                      <Typography fontWeight="fontWeightBold">
                        {StatusIcon(key)}
                        {key}
                      </Typography>
                    </Grid>
                    <Grid item xs={7}>
                      <Typography>{value}</Typography>
                    </Grid>
                  </Grid>
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Paper elevation={3} sx={{ padding: 1, marginBottom: 1 }}>
            <List dense>
              {metrics.map((item, i) => (
                <ListItem key={i} divider>
                  <Grid container spacing={1}>
                    <Grid item xs={6}>
                      <Typography fontWeight="fontWeightBold" noWrap>
                        {item.label}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography>
                        {i === 0 ||
                        item.impact === null ||
                        item.impact === "" ||
                        item.label === "SP Clicks" ||
                        item.label === "SB Clicks" ||
                        item.label === "Paid Units"
                          ? numberFormatter(item.impact)
                          : currencyFormatter(item.impact)}
                      </Typography>
                    </Grid>
                  </Grid>
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DetailsPanelSummary;
